import { render, staticRenderFns } from "./cell.vue?vue&type=template&id=634238da&"
import script from "./cell.vue?vue&type=script&lang=js&"
export * from "./cell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634238da')) {
      api.createRecord('634238da', component.options)
    } else {
      api.reload('634238da', component.options)
    }
    module.hot.accept("./cell.vue?vue&type=template&id=634238da&", function () {
      api.rerender('634238da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/cell.vue"
export default component.exports